import Grid from '@mui/material/Grid'
import FormControl from '@mui/material/FormControl'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import {
    ANIMAL_SHIPPING_POLICY_TYPES,
    changeAnimalShippingPolicyType,
    DEFAULT_ANIMAL_SHIPPING_POLICY,
} from './animalShippingPolicy'

export default function AnimalShippingPolicyFields({ data, setData }) {
    const updateField = (field, value) => {
        setData((prev) => ({
            ...prev,
            [field]: value,
        }))
    }

    const handlePolicyTypeChange = (event) => {
        const shippingPolicyType = event.target.value

        setData((prev) => changeAnimalShippingPolicyType(prev, shippingPolicyType))
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
                <FormControl fullWidth>
                    <TextField
                        select
                        required
                        label="배송 정책"
                        id="shippingPolicyType"
                        name="shippingPolicyType"
                        value={data.shippingPolicyType}
                        onChange={handlePolicyTypeChange}
                        size="small"
                    >
                        <MenuItem value={ANIMAL_SHIPPING_POLICY_TYPES.FREE}>무료배송</MenuItem>
                        <MenuItem value={ANIMAL_SHIPPING_POLICY_TYPES.CONDITIONAL}>조건부 무료배송</MenuItem>
                    </TextField>
                </FormControl>
            </Grid>
            <Grid item xs={12} md={4}>
                <FormControl fullWidth>
                    <TextField
                        required
                        label="배송비"
                        id="shippingPrice"
                        name="shippingPrice"
                        type="number"
                        value={data.shippingPrice}
                        disabled={data.shippingPolicyType === ANIMAL_SHIPPING_POLICY_TYPES.FREE}
                        onChange={(event) => updateField('shippingPrice', event.target.value)}
                        size="small"
                        InputProps={{
                            inputProps: {
                                min: data.shippingPolicyType === ANIMAL_SHIPPING_POLICY_TYPES.CONDITIONAL ? 1 : 0,
                                step: 1,
                            },
                        }}
                        helperText="동일 productId의 여러 코스 주문에도 1회 부과됩니다."
                    />
                </FormControl>
            </Grid>
            {data.shippingPolicyType === ANIMAL_SHIPPING_POLICY_TYPES.CONDITIONAL && (
                <Grid item xs={12} md={4}>
                    <FormControl fullWidth>
                        <TextField
                            label="무료배송 기준 금액"
                            id="freeShippingThreshold"
                            name="freeShippingThreshold"
                            type="number"
                            value={DEFAULT_ANIMAL_SHIPPING_POLICY.freeShippingThreshold}
                            disabled
                            size="small"
                            helperText="현재 정책상 29,800원으로 고정되어 있습니다."
                        />
                    </FormControl>
                </Grid>
            )}
        </Grid>
    )
}
